let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lGaKH")).then(() => parcelRequire('55qHL'));